import React from 'react';
import { Table, Input, DatePicker, Button, Space } from 'antd';

const { Search } = Input;
const { RangePicker } = DatePicker;

const columns = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    key: 'timestamp',
    sorter: (a: any, b: any) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: 'user',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
  },
  {
    title: 'Target',
    dataIndex: 'target',
    key: 'target',
  },
    {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
  },
  {
    title: 'Source IP',
    dataIndex: 'ip',
    key: 'ip',
  },
];

const data = [
  {
    key: '1',
    timestamp: '2025-11-10 14:20:15',
    user: 'superadmin@platform.com',
    action: 'CREATE_TENANT',
    target: 'Tenant ID: customer-delta',
    details: 'Name: Customer Delta, Max Instances: 10',
    ip: '203.0.113.1',
  },
  {
    key: '2',
    timestamp: '2025-11-10 11:05:30',
    user: 'sre-team@platform.com',
    action: 'CORDON_NODE',
    target: 'Node: 192.168.1.103',
    details: 'Reason: Memory upgrade',
    ip: '10.0.1.5',
  },
  {
    key: '3',
    timestamp: '2025-11-09 18:00:00',
    user: 'superadmin@platform.com',
    action: 'UPDATE_GLOBAL_CONFIG',
    target: 'System Default Settings',
    details: 'defaultTaskTimeout changed from 600 to 900',
    ip: '203.0.113.1',
  },
    {
    key: '4',
    timestamp: '2025-11-10 15:00:00',
    user: 'support-lead@platform.com',
    action: 'VIEW_USER_DATA',
    target: 'Tenant: Customer Alpha, Task ID: task-xyz-123',
    details: 'Accessed analysis report for support ticket #5543',
    ip: '10.0.2.8',
  },
];

const AuditLogPage = () => {
  const onSearch = (value: string) => console.log(value);

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Search placeholder="Search by user, action, or target" onSearch={onSearch} style={{ width: 300 }} />
        <RangePicker showTime />
        <Button type="primary">Filter</Button>
        <Button>Export as CSV</Button>
      </Space>
      <Table columns={columns} dataSource={data} />
    </div>
  );
};

export default AuditLogPage;
